var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"component",staticClass:"uk-button uk-width-1-1",class:[_vm.color, _vm.uksize],attrs:{"to":_vm.to,"color":_vm.color,"type":_vm.type}},[_vm._t("default",[_vm._v("Submit")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }